import { useEffect } from "react";
import { CASE_STUDY_ORIGIN } from "@/data/case-studies";

export function useCaseStudySeo(meta: { path: string; title: string; description: string; image: string }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = meta.title;
    const removed = [...document.head.querySelectorAll('meta[name="description"],link[rel="canonical"],meta[property^="og:"],meta[name^="twitter:"]')];
    removed.forEach(n => n.remove());
    const added: Element[] = [];
    const add = (tag: string, attrs: Record<string, string>) => {
      const n = document.createElement(tag);
      Object.entries(attrs).forEach(([k, v]) => n.setAttribute(k, v));
      document.head.appendChild(n);
      added.push(n);
    };
    const url = CASE_STUDY_ORIGIN + meta.path;
    const image = CASE_STUDY_ORIGIN + meta.image;
    add("link", { rel: "canonical", href: url });
    add("meta", { name: "description", content: meta.description });
    add("meta", { name: "twitter:card", content: "summary_large_image" });
    add("meta", { name: "twitter:image", content: image });
    for (const [property, content] of Object.entries({ "og:title": meta.title, "og:description": meta.description, "og:url": url, "og:image": image, "og:type": "article", "og:locale": "en_GB" }))
      add("meta", { property, content });
    window.scrollTo(0, 0);
    return () => {
      added.forEach(n => n.remove());
      removed.forEach(n => document.head.appendChild(n));
      document.title = prevTitle;
    };
  }, [meta]);
}
